import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// TODO: スカルプカメラ連携は Phase 2 対象外。カメラ連携で使用する Radio は、後で必要があれば復活させる。
// import { Form, Input, Checkbox, Button, Radio, Select } from 'antd';
import { Form, Input, Checkbox, Button, Select } from 'antd';
import _ from 'lodash';

// TODO: スカルプカメラ連携は Phase 2 対象外。カメラ連携で使用する determineUserAgent は、後で必要があれば復活させる。
// import { checkOrientation, determineUserAgent } from '../../../utils';
import { checkOrientation } from '../../../utils';

import putSalonSettings from '../../../redux/actions/putSalonSettings';
import { updateScalpCameraOption, getScalpCameraGuide } from '../../../redux/actions/scalpCameraOption';
import {
  Container,
  Title,
  Hr,
  SelectSection,
  SelectBase,
  FormItemTitle,
  SectionGroupCommon,
  TitleDesc,
  ACheckboxGroupCover,
  SalonMenuGroup,
  SalonItemTitle,
  SalonMenuSubGroup,
  MenuItems,
  MenuItem,
  InputWrapper,
  // TODO: スカルプカメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
  // RadioWrapper,
  CurrencySymbol,
  QA,
  SubmitCover,
  ErrorMessage,
  BottomMargin,
  // TODO: スカルプカメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
  // SectionGroupRadio,
  Spinner,
  // TODO: スカルプカメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
  // SectionGroupCameraApp,
  // DescriptionText,
  // ButtonWrapper,
  // DLButton,
  // DownloadSvg,
  // ManualLink,
} from './SettingPage.style';
import './style.less';
import fechSpAuthSalonSettings from '../../../redux/actions/authSalonSettings';
import { fetchUser } from '../../../redux/actions/user';
// TODO: スカルプカメラ連携は Phase 2 対象外。以下の svg は、後で必要があれば復活させる。
// import downloadSvg from '../../../assets/images/download.svg';
// TODO: スカルプカメラ連携は Phase 2 対象外。以下のモーダルコンポーネントは、後で必要があれば復活させる。
// import Modal from '../../../components/Modal/RecieverFragments';
import Placeholder from '../../../components/Placeholder';

class SettingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orientationStr: '',
      homeCareCheckedList: [],
      treatmentList: [],
      spaList: [],
      useCamera: _.get(props.salonSetting, 'others.useCamera') || '',
      loadData: false,
      treatmentListInitValue: {},
      spaListInitValue: {},
      isErrorMsg: false,
      isHomeCareCheckedList: false,
      isTreatmentList: false,
      isSpaChecked: false,
      isCurrency: false,
      isCurrencyChanged: false,
      // ホームケアアイテムの入力フォームを変更したかどうかを真偽で受ける (変更あり: true、変更なし: false)
      isHomeCareChanged: false,
      SSHTarget: true,
      SSHShield: true,
      SSHDetox: true,
      SSHIntensive: true,
      SSHReforming: true,
      SSSSolvingProblem: true,
      SSSLifting: true,
      SSSComplete: true,
      loading: false,
      isModalOpen: false,
      // サロンメニュー設定の通貨マーク表示
      symbol: '',
      // 未登録、且つ、サロンメニュー設定のチェックボックスが ON になった時に、slug と共に状態をキャッシュする
      //   目的: 未登録時の通貨マーク表示状態を制御するのに使用する
      currencyForms: {},
    };

    // スカルプカメラ・ダウンロードマニュアルを取得する
    props.getScalpCameraGuide(props.locale);

    // 「診断にカメラを使用しない/する」ラジオボタン選択用ハンドラ
    this.handlerChangeCameraOption = this.handlerChangeCameraOption.bind(this);
    // モーダルの開/閉状態をコントロールするハンドラ
    this.handlerControlModal = this.handlerControlModal.bind(this);
  }

  componentWillMount = () => {
    const { salonSetting, authSalonSettings } = this.props;
    const datum =
      salonSetting.basicSettings &&
      authSalonSettings.basicSettings &&
      _.find(salonSetting.basicSettings, item => item.code === authSalonSettings.basicSettings.currencyCode);

    if (_.get(datum, 'symbol')) {
      // サロンメニュー設定の通貨マークをキャッシュしておく
      this.setState({ symbol: datum.symbol });
    }
  };

  componentDidMount() {
    checkOrientation(this);

    const { auth, fetchUser, getSpauthSeting } = this.props;

    if (auth && auth.info && auth.info.username) {
      fetchUser(auth.info.username).then(({ value }) => {
        getSpauthSeting(value.user.salonId).then(() => {
          this.loadAuthSalonSettings(this.props.authSalonSettings);
        });
      });
    }
  }

  componentDidUpdate() {
    const { authSalonSettings } = this.props;
    if (authSalonSettings && authSalonSettings.id && !this.state.loadData) {
      this.loadAuthSalonSettings(authSalonSettings);
    }
  }

  onTreatmentChange = (e, data) => {
    const { checked } = e.target;
    if (checked) {
      this.setState({
        treatmentList: [...this.state.treatmentList, data.slug],
        isTreatmentList: false,
        [data.slug.replace(/-/g, '')]: false,
        // 通貨マークを表示させる (但し、未登録の場合のみの対応)
        currencyForms: { treatment: { [data.slug]: true } },
      });
    } else {
      this.setState({
        treatmentList: [...this.state.treatmentList.filter(item => item !== data.slug)],
        [data.slug.replace(/-/g, '')]: true,
        isErrorMsg: false,
        // 通貨マークを非表示にする (但し、未登録の場合のみの対応)
        currencyForms: { treatment: { [data.slug]: false } },
      });
    }
  };

  onSpaChange = (e, data) => {
    const { checked } = e.target;
    if (checked) {
      this.setState({
        spaList: [...this.state.spaList, data.slug],
        [data.slug.replace(/-/g, '')]: false,
        isSpaChecked: false,
        // 通貨マークを表示させる (但し、未登録の場合のみの対応)
        currencyForms: { spa: { [data.slug]: true } },
      });
    } else {
      this.setState({
        spaList: [...this.state.spaList.filter(item => item !== data.slug)],
        [data.slug.replace(/-/g, '')]: true,
        isErrorMsg: false,
        // 通貨マークを非表示にする (但し、未登録の場合のみの対応)
        currencyForms: { spa: { [data.slug]: false } },
      });
    }
  };

  onHomeCareChange = (e, data) => {
    // 初期ロード時のバリデーションエラー表示を回避するためにキャッシュしておく
    this.setState({ isHomeCareChanged: true });

    const { checked } = e.target;
    if (checked) {
      this.setState({ homeCareCheckedList: [...this.state.homeCareCheckedList, data.slug] });
    } else {
      this.setState({ homeCareCheckedList: [...this.state.homeCareCheckedList.filter(item => item !== data.slug)] });
    }
  };

  handleSubmit = e => {
    const { history, putSalonSettings, locale, copy, getSpauthSeting, form } = this.props;
    const { currencyHintLabel } = (copy && copy.salonSetting && copy.salonSetting) || [];
    this.setState({ isFirstLoad: false });

    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        const { homeCareCheckedList, treatmentList, spaList, loading, useCamera } = this.state;
        const { salonSetting, stylist } = this.props;
        const { links } = (salonSetting.others && salonSetting.others) || [];
        if (loading) return;
        const data = {
          salonId: stylist.salonId,
          basicSettings: {
            currencyCode: values.currency,
          },
          homeCareItems: homeCareCheckedList,
          salonMenus: {
            treatments: [],
            spas: [],
          },
          others: {
            useCamera,
            links,
          },
        };
        if (this.state.homeCareCheckedList.length === 0) {
          this.setState({ isHomeCareCheckedList: true, isErrorMsg: true });
        } else if (values.currency === currencyHintLabel) {
          this.setState({ isCurrency: true, isErrorMsg: true });
        } else if (treatmentList.length === 0) {
          this.setState({ isTreatmentList: true, isErrorMsg: true });
        } else if (spaList.length === 0) {
          this.setState({ isSpaChecked: true, isErrorMsg: true });
        } else {
          this.setState({
            isHomeCareCheckedList: false,
            isErrorMsg: false,
            isCurrency: false,
            isTreatmentList: false,
            isSpaChecked: false,
            loading: true,
          });
          treatmentList.map(treatmentSlug => {
            if (values[`treatment_${treatmentSlug}`]) {
              const treatment = {};
              treatment.slug = treatmentSlug;
              treatment.displayName = values[`treatment_${treatmentSlug}_inp_name`];
              treatment.operationTime = values[`treatment_${treatmentSlug}_inp_time`];
              treatment.price = values[`treatment_${treatmentSlug}_inp_price`];
              data.salonMenus.treatments.push(treatment);
            }
          });
          spaList.map(spaSlug => {
            if (values[`spa_${spaSlug}`]) {
              const spa = {};
              spa.slug = spaSlug;
              spa.displayName = values[`spa_${spaSlug}_inp_name`];
              spa.operationTime = values[`spa_${spaSlug}_inp_time`];
              spa.price = values[`spa_${spaSlug}_inp_price`];
              data.salonMenus.spas.push(spa);
            }
          });
          putSalonSettings(data).then(() => {
            getSpauthSeting(data.salonId);
          });
          history.push(`/${locale}/salon-consultation/home`);
        }
      } else {
        this.setState({
          isErrorMsg: true,
          loading: false,
        });
      }
    });
  };

  loadAuthSalonSettings = authSalonSettings => {
    const treatmentListInitValue = {};
    const spaListInitValue = {};
    let treatmentList = [];
    let spaList = [];
    const homeCareCheckedList = authSalonSettings.homeCareItems !== null ? authSalonSettings.homeCareItems : [];

    if (authSalonSettings.salonMenus !== null) {
      if (typeof authSalonSettings.salonMenus.treatments !== 'undefined') {
        authSalonSettings.salonMenus.treatments.map(menu => {
          treatmentListInitValue[menu.slug] = menu;
          return true;
        });
        treatmentList = authSalonSettings.salonMenus.treatments.map(menu => menu.slug);
      }
      if (authSalonSettings.salonMenus.spas !== null) {
        authSalonSettings.salonMenus.spas.map(menu => {
          spaListInitValue[menu.slug] = menu;
          return true;
        });
        spaList = authSalonSettings.salonMenus.spas.map(menu => menu.slug);
      }
    }

    this.setState({
      homeCareCheckedList,
      treatmentList,
      spaList,
      useCamera: (authSalonSettings.others && authSalonSettings.others.useCamera) || '',
      treatmentListInitValue,
      spaListInitValue,
      loadData: true,
      SSHTarget: !treatmentList.includes('SS-H-Target'),
      SSHShield: !treatmentList.includes('SS-H-Shield'),
      SSHDetox: !treatmentList.includes('SS-H-Detox'),
      SSHIntensive: !treatmentList.includes('SS-H-Intensive'),
      SSHReforming: !treatmentList.includes('SS-H-Reforming'),
      SSSSolvingProblem: !spaList.includes('SS-S-SolvingProblem'),
      SSSLifting: !spaList.includes('SS-S-Lifting'),
      SSSComplete: !spaList.includes('SS-S-Complete'),
    });
  };

  handleCurrencyChange = value => {
    const { copy, salonSetting } = this.props;

    const { currencyHintLabel } = (copy && copy.salonSetting && copy.salonSetting) || [];

    if (value === currencyHintLabel) {
      this.setState({ isCurrency: true });
    } else {
      const { symbol } = salonSetting.basicSettings && _.find(salonSetting.basicSettings, item => item.code === value);
      this.setState({ isCurrency: false, isErrorMsg: false, isCurrencyChanged: true, symbol });
    }
  };
  handleSpaInputChange = (slug, type) => e => {
    const { spaListInitValue } = this.state;
    spaListInitValue[slug] = { ...spaListInitValue[slug], [type]: e.target.value };
    this.setState({
      spaListInitValue,
      isErrorMsg: false,
    });
  };

  handleTreatmentInputChange = (slug, type) => e => {
    const { treatmentListInitValue } = this.state;
    treatmentListInitValue[slug] = { ...treatmentListInitValue[slug], [type]: e.target.value };

    this.setState({
      treatmentListInitValue,
      isErrorMsg: false,
    });
  };

  /**
   * 「診断にカメラを使用しない/する」ラジオボタンを選択した時に呼ばれる
   */
  handlerChangeCameraOption = event => {
    this.setState({
      useCamera: event.target.value,
      isErrorMsg: false,
      isFirstLoad: false,
    });

    // カメラ使用可否の真偽値 state を更新させる (再レンダーを目的とする)
    this.props.updateScalpCameraOption({ isSelectedCameraOption: event.target.value });
  };

  /**
   * モーダルの開/閉ボタン押下時に呼ばれる
   */
  handlerControlModal = isModalOpen => this.setState({ isModalOpen });

  render() {
    // TODO: スカルプカメラ連携は Phase 2 対象外。cameraOption と scalpCameraGuide は、後で必要があれば復活させる。
    // const { copy, salonSetting, authSalonSettings, cameraOption, scalpCameraGuide } = this.props;
    const { copy, salonSetting, authSalonSettings } = this.props;
    // TODO: スカルプカメラ連携は Phase 2 対象外。isSelectedCameraOption は、後で必要があれば復活させる。
    // const { isSelectedCameraOption } = cameraOption;
    const { getFieldDecorator } = this.props.form;
    const {
      orientationStr,
      homeCareCheckedList,
      treatmentList,
      spaList,
      treatmentListInitValue,
      spaListInitValue,
      isErrorMsg,
      isCurrency,
      isCurrencyChanged,
      isHomeCareChanged,
      isTreatmentList,
      isSpaChecked,
      loading,
      // TODO: スカルプカメラ連携は Phase 2 対象外。isModalOpen は、後で必要があれば復活させる。
      // isModalOpen,
      symbol,
      currencyForms,
    } = this.state;

    const {
      title,
      basicSettingTitle,
      currencyHintLabel,
      homeCareItemSettingTitle,
      homeCareItemSettingDescription,
      salonMenuSettingTitle,
      salonMenuSettingDescription,
      saveSetting,
      // TODO: スカルプカメラ連携は Phase 2 対象外。otherSettingTitle は、後で必要があれば復活させる。
      // otherSettingTitle,
      treatmentTitle,
      spaTitle,
      displayNameLabel,
      operationTimeLabel,
      priceLabel,
    } =
      (copy && copy.salonSetting && copy.salonSetting) || [];
    const errorMessage = (copy && copy.errorMessage) || [];
    const { homeCareItems, salonMenus, others } = (salonSetting && salonSetting) || [];
    const isCurrencyHint =
      (authSalonSettings &&
        authSalonSettings.basicSettings &&
        authSalonSettings.basicSettings.currencyCode &&
        authSalonSettings.basicSettings.currencyCode) ||
      currencyHintLabel;

    return (
      <Container>
        {!title ? <Placeholder w="100%" h="24px" m="20px 0 0 0" /> : <Title>{title}</Title>}
        <Hr />
        <Form onSubmit={this.handleSubmit}>
          <Form.Item>
            <SelectSection>
              {!basicSettingTitle ? (
                <Placeholder w="140px" h="40px" />
              ) : (
                <FormItemTitle>{basicSettingTitle}</FormItemTitle>
              )}
              <React.Fragment>
                {!(authSalonSettings && currencyHintLabel && salonSetting) ? (
                  <Placeholder w="100%" h="24px" />
                ) : (
                  <Form.Item>
                    {getFieldDecorator('currency', {
                      rules: [{ required: true }],
                      initialValue:
                        (authSalonSettings &&
                          authSalonSettings.basicSettings &&
                          authSalonSettings.basicSettings.currencyCode &&
                          authSalonSettings.basicSettings.currencyCode) ||
                        currencyHintLabel ||
                        '',
                    })(
                      <SelectBase onChange={this.handleCurrencyChange} dropdownClassName="select-options">
                        {salonSetting &&
                          salonSetting.basicSettings &&
                          salonSetting.basicSettings.map(({ code, entryId, name, symbol }) => (
                            <Select.Option value={code} key={entryId}>{`${symbol} (${name})`}</Select.Option>
                          ))}
                      </SelectBase>
                    )}
                  </Form.Item>
                )}
              </React.Fragment>
            </SelectSection>
          </Form.Item>
          {isCurrency && (isCurrencyChanged ? false : currencyHintLabel === isCurrencyHint) ? (
            <React.Fragment>
              {!errorMessage ? (
                <Placeholder w="100%" h="24px" />
              ) : (
                <ErrorMessage currency>{errorMessage.notSelectedCurrency}</ErrorMessage>
              )}
            </React.Fragment>
          ) : null}
          <Hr />
          {/* ホームケアアイテム設定 */}
          <Form.Item>
            <SectionGroupCommon>
              {!homeCareItemSettingTitle ? (
                <Placeholder w="100%" h="24px" />
              ) : (
                <FormItemTitle>{homeCareItemSettingTitle}</FormItemTitle>
              )}
              {!homeCareItemSettingDescription ? (
                <Placeholder w="100%" h="24px" />
              ) : (
                <TitleDesc>{homeCareItemSettingDescription}</TitleDesc>
              )}
              <React.Fragment>
                {!homeCareItems ? (
                  <Placeholder w="100%" h="24px" />
                ) : (
                  <Form.Item>
                    {getFieldDecorator('checkbox-group', {
                      rules: [{ required: false }],
                      initialValue: homeCareCheckedList,
                    })(
                      <ACheckboxGroupCover orientationStr={orientationStr}>
                        {homeCareItems.map(({ slug, name, entryId }) => (
                          <Checkbox
                            style={{ borderColor: homeCareCheckedList.includes(slug) ? '#000' : '#e0e0e0' }}
                            checked={homeCareCheckedList.includes(slug)}
                            key={entryId}
                            onChange={e => {
                              this.onHomeCareChange(e, { slug, name });
                            }}
                          >
                            {name}
                          </Checkbox>
                        ))}
                      </ACheckboxGroupCover>
                    )}
                  </Form.Item>
                )}
              </React.Fragment>
              {Boolean(isHomeCareChanged && homeCareCheckedList.length === 0) && (
                <React.Fragment>
                  {!errorMessage ? (
                    <Placeholder w="100%" h="24px" />
                  ) : (
                    <ErrorMessage>{errorMessage.notSelectedHomeCareItem}</ErrorMessage>
                  )}
                </React.Fragment>
              )}
            </SectionGroupCommon>
          </Form.Item>
          {/* End of ホームケアアイテム設定 */}
          <Hr />
          {/* サロンメニュー設定 */}
          <Form.Item>
            <SectionGroupCommon>
              {!salonMenuSettingTitle ? (
                <Placeholder w="100%" h="24px" />
              ) : (
                <FormItemTitle>{salonMenuSettingTitle}</FormItemTitle>
              )}
              {!salonMenuSettingDescription ? (
                <Placeholder w="100%" h="24px" />
              ) : (
                <TitleDesc>{salonMenuSettingDescription}</TitleDesc>
              )}
              <SalonMenuGroup>
                {/* トリートメントメニュー */}
                <MenuItems className="treatmentItems">
                  {!treatmentTitle ? (
                    <Placeholder w="100%" h="24px" />
                  ) : (
                    <SalonItemTitle>{treatmentTitle}</SalonItemTitle>
                  )}
                  {isTreatmentList && (
                    <React.Fragment>
                      {!errorMessage ? (
                        <Placeholder w="100%" h="24px" />
                      ) : (
                        <ErrorMessage>{errorMessage.notEnteredTreatmentMenu}</ErrorMessage>
                      )}
                    </React.Fragment>
                  )}
                  {!salonMenus || (salonMenus && salonMenus.treatments.length === 0) ? (
                    <Placeholder w="100%" h="24px" />
                  ) : (
                    <React.Fragment>
                      {salonMenus.treatments.map(({ slug, name, entryId }) => (
                        <SalonMenuSubGroup key={entryId}>
                          {getFieldDecorator(`treatment_${slug}`, {
                            initialValue: treatmentList.includes(slug),
                            rules: [
                              {
                                required: true,
                                message: `${errorMessage.notEnteredTreatmentMenu}`,
                              },
                            ],
                          })(
                            <Checkbox
                              onChange={e => {
                                this.onTreatmentChange(e, { slug, name });
                              }}
                              checked={treatmentList.includes(slug)}
                            >
                              {name}
                            </Checkbox>
                          )}
                          <MenuItem isChecked={!this.state[slug.replace(/-/g, '')]}>
                            {/* 入力フォーム (メニュー) */}
                            <Form.Item>
                              {getFieldDecorator(`treatment_${slug}_inp_name`, {
                                rules: treatmentList.includes(slug)
                                  ? [
                                      {
                                        required: true,
                                        message: `${errorMessage.notEnteredDisplayName}`,
                                      },
                                    ]
                                  : [{ required: false }],
                                initialValue:
                                  (treatmentListInitValue[slug] && treatmentListInitValue[slug].displayName) || null,
                              })(
                                <InputWrapper>
                                  <Input
                                    name="menu"
                                    type="text"
                                    placeholder={displayNameLabel}
                                    value={
                                      (treatmentListInitValue[slug] && treatmentListInitValue[slug].displayName) || null
                                    }
                                    onChange={this.handleTreatmentInputChange(slug, 'displayName')}
                                    disabled={this.state[slug.replace(/-/g, '')]}
                                  />
                                </InputWrapper>
                              )}
                            </Form.Item>
                            {/* 入力フォーム (施術時間) */}
                            <Form.Item>
                              {getFieldDecorator(`treatment_${slug}_inp_time`, {
                                rules: treatmentList.includes(slug)
                                  ? [{ required: true, message: `${errorMessage.notEnteredTime}` }]
                                  : [{ required: false }],
                                initialValue:
                                  (treatmentListInitValue[slug] && treatmentListInitValue[slug].operationTime) || null,
                              })(
                                <InputWrapper>
                                  <Input
                                    type="text"
                                    placeholder={operationTimeLabel}
                                    value={
                                      (treatmentListInitValue[slug] && treatmentListInitValue[slug].operationTime) ||
                                      null
                                    }
                                    onChange={this.handleTreatmentInputChange(slug, 'operationTime')}
                                    disabled={this.state[slug.replace(/-/g, '')]}
                                  />
                                </InputWrapper>
                              )}
                            </Form.Item>
                            {/* 入力フォーム (金額) */}
                            <Form.Item>
                              {getFieldDecorator(`treatment_${slug}_inp_price`, {
                                rules: treatmentList.includes(slug)
                                  ? [{ required: true, message: `${errorMessage.notEnteredPrice}` }]
                                  : [{ required: false }],
                                initialValue:
                                  (treatmentListInitValue[slug] && treatmentListInitValue[slug].price) || null,
                              })(
                                <InputWrapper>
                                  {!!(
                                    treatmentListInitValue[slug] ||
                                    (_.get(currencyForms, 'treatment') && currencyForms.treatment[slug])
                                  ) && <CurrencySymbol>{symbol}</CurrencySymbol>}
                                  <Input
                                    type="number"
                                    name="currency"
                                    placeholder={priceLabel}
                                    value={(treatmentListInitValue[slug] && treatmentListInitValue[slug].price) || null}
                                    onChange={this.handleTreatmentInputChange(slug, 'price')}
                                    disabled={this.state[slug.replace(/-/g, '')]}
                                  />
                                </InputWrapper>
                              )}
                            </Form.Item>
                          </MenuItem>
                        </SalonMenuSubGroup>
                      ))}
                    </React.Fragment>
                  )}
                </MenuItems>
                {/* End of トリートメントメニュー */}
                {/* スパメニュー */}
                <MenuItems>
                  {!spaTitle ? <Placeholder w="100%" h="24px" /> : <SalonItemTitle>{spaTitle}</SalonItemTitle>}
                  {isSpaChecked && (
                    <React.Fragment>
                      {!errorMessage ? (
                        <Placeholder w="100%" h="24px" />
                      ) : (
                        <ErrorMessage>{errorMessage.notEnteredSpaMenu}</ErrorMessage>
                      )}
                    </React.Fragment>
                  )}
                  {!salonMenus || (salonMenus && salonMenus.spas.length === 0) ? (
                    <Placeholder w="100%" h="24px" />
                  ) : (
                    <React.Fragment>
                      {salonMenus.spas.map(({ slug, name, entryId }) => (
                        <SalonMenuSubGroup key={entryId}>
                          {getFieldDecorator(`spa_${slug}`, {
                            initialValue: spaList.includes(slug),
                            rules: [{ required: false }],
                          })(
                            <Checkbox
                              onChange={e => {
                                this.onSpaChange(e, { slug, name });
                              }}
                              checked={spaList.includes(slug)}
                            >
                              {name}
                            </Checkbox>
                          )}
                          <MenuItem isChecked={!this.state[slug.replace(/-/g, '')]}>
                            {/* 入力フォーム (メニュー) */}
                            <Form.Item>
                              {getFieldDecorator(`spa_${slug}_inp_name`, {
                                rules: spaList.includes(slug)
                                  ? [
                                      {
                                        required: true,
                                        message: `${errorMessage.notEnteredDisplayName}`,
                                      },
                                    ]
                                  : [{ required: false }],
                                initialValue: (spaListInitValue[slug] && spaListInitValue[slug].displayName) || null,
                              })(
                                <InputWrapper>
                                  <Input
                                    name="menu"
                                    type="text"
                                    placeholder={displayNameLabel}
                                    value={(spaListInitValue[slug] && spaListInitValue[slug].displayName) || null}
                                    onChange={this.handleSpaInputChange(slug, 'displayName')}
                                    disabled={this.state[slug.replace(/-/g, '')]}
                                  />
                                </InputWrapper>
                              )}
                            </Form.Item>
                            {/* 入力フォーム (施術時間) */}
                            <Form.Item>
                              {getFieldDecorator(`spa_${slug}_inp_time`, {
                                rules: spaList.includes(slug)
                                  ? [{ required: true, message: `${errorMessage.notEnteredTime}` }]
                                  : [{ required: false }],
                                initialValue: (spaListInitValue[slug] && spaListInitValue[slug].operationTime) || null,
                              })(
                                <InputWrapper>
                                  <Input
                                    type="text"
                                    placeholder={operationTimeLabel}
                                    value={(spaListInitValue[slug] && spaListInitValue[slug].operationTime) || null}
                                    onChange={this.handleSpaInputChange(slug, 'operationTime')}
                                    disabled={this.state[slug.replace(/-/g, '')]}
                                  />
                                </InputWrapper>
                              )}
                            </Form.Item>
                            {/* 入力フォーム (金額) */}
                            <Form.Item>
                              {getFieldDecorator(`spa_${slug}_inp_price`, {
                                rules: spaList.includes(slug)
                                  ? [{ required: true, message: `${errorMessage.notEnteredPrice}` }]
                                  : [{ required: false }],
                                initialValue: (spaListInitValue[slug] && spaListInitValue[slug].price) || null,
                              })(
                                <InputWrapper>
                                  {!!(
                                    spaListInitValue[slug] ||
                                    (_.get(currencyForms, 'spa') && currencyForms.spa[slug])
                                  ) && <CurrencySymbol>{symbol}</CurrencySymbol>}
                                  <Input
                                    type="number"
                                    name="currency"
                                    placeholder={priceLabel}
                                    value={(spaListInitValue[slug] && spaListInitValue[slug].price) || null}
                                    onChange={this.handleSpaInputChange(slug, 'price')}
                                    disabled={this.state[slug.replace(/-/g, '')]}
                                  />
                                </InputWrapper>
                              )}
                            </Form.Item>
                          </MenuItem>
                        </SalonMenuSubGroup>
                      ))}
                    </React.Fragment>
                  )}
                </MenuItems>
                {/* End of スパメニュー */}
              </SalonMenuGroup>
            </SectionGroupCommon>
          </Form.Item>
          <Hr spa />
          {/* TODO: Phase 2 対象外。後で必要があれば復活させる。
          <SectionGroupCommon>
            <SectionGroupCommon>
              <SectionGroupRadio>
                {!otherSettingTitle ? (
                  <Placeholder w="100%" h="24px" />
                ) : (
                  <FormItemTitle>{otherSettingTitle}</FormItemTitle>
                )}
                <React.Fragment>
                  {!others ? (
                    <Placeholder w="100%" h="24px" />
                  ) : (
                    <Form.Item>
                      {getFieldDecorator('camera', {
                        initialValue: this.state.useCamera,
                        rules: [{ required: true, message: `${errorMessage.notSelectedCamera}` }],
                      })(
                        <RadioWrapper orientationStr={orientationStr} onChange={this.handlerChangeCameraOption}>
                          <Radio value="false" className={this.state.useCamera === 'false' ? 'active' : ''}>
                            {others && others.useCameraFalseLabel}
                          </Radio>
                          <Radio value="true" className={this.state.useCamera === 'true' ? 'active' : ''}>
                            {others && others.useCameraTrueLabel}
                          </Radio>
                        </RadioWrapper>
                      )}
                    </Form.Item>
                  )}
                </React.Fragment>
              </SectionGroupRadio>
            </SectionGroupCommon>
          </SectionGroupCommon>
          */}
          {/* TODO: Phase 2 対象外。後で必要があれば復活させる。
          {Boolean(
            ((isSelectedCameraOption === '' && this.state.useCamera) || isSelectedCameraOption === 'true') &&
              (determineUserAgent().isIOS || determineUserAgent().isAndroid)
          ) && (
            <React.Fragment>
              {!(
                scalpCameraGuide &&
                _.includes(
                  scalpCameraGuide,
                  scalpCameraGuide.description,
                  scalpCameraGuide.url,
                  scalpCameraGuide.button
                ) &&
                _.get(scalpCameraGuide, 'manual.title')
              ) ? (
                <Placeholder w="100%" h="210px" />
              ) : (
                <SectionGroupCameraApp>
                  <React.Fragment>
                    <DescriptionText>{scalpCameraGuide.description}</DescriptionText>
                    <ButtonWrapper>
                      <a href={scalpCameraGuide.url}>
                        <DLButton onClick={() => this.handlerControlModal(true)}>
                          <DownloadSvg src={downloadSvg} alt="download" />
                          {scalpCameraGuide.button}
                        </DLButton>
                      </a>
                    </ButtonWrapper>
                    <ManualLink onClick={() => this.handlerControlModal(true)}>
                      {_.get(scalpCameraGuide, 'manual.title')}
                    </ManualLink>
                  </React.Fragment>
                  <Modal
                    isOpen={isModalOpen}
                    hasHeader
                    onClose={() => this.handlerControlModal(false)}
                    hasHeading={!!_.get(scalpCameraGuide, 'manual.title')}
                    hasBodyDescription={!!_.get(scalpCameraGuide, 'manual.description')}
                    contentHeading={_.get(scalpCameraGuide, 'manual.title')}
                    contentBodyDescription={_.get(scalpCameraGuide, 'manual.description')}
                    contentBodyItems={[
                      { type: 'IMAGE_MARKDOWN', item: _.get(scalpCameraGuide, 'manual.manual') },
                      { type: 'NOTE_TITLE', item: _.get(scalpCameraGuide, 'manual.note.title') },
                      { type: 'NOTE_CONTENT', item: _.get(scalpCameraGuide, 'manual.note.content') },
                    ]}
                    styleType="installManualType"
                  />
                </SectionGroupCameraApp>
              )}
            </React.Fragment>
          )}
          */}
          {others &&
            others.links &&
            others.links.map(({ label, url, external, entryId }) => (
              <QA key={entryId} href={url} target={external ? '_top' : '_blank'}>
                {label}
              </QA>
            ))}
          {/* TODO: スカルプカメラ動線を復活させたら、Hr タグも復活させること。(2019年12月04日) */}
          {/* <Hr /> */}
          <SubmitCover disabled={loading}>
            <Button htmlType="submit">{loading ? <Spinner /> : saveSetting}</Button>
          </SubmitCover>
          {isErrorMsg && <ErrorMessage>{errorMessage.formError}</ErrorMessage>}
          <BottomMargin />
        </Form>
      </Container>
    );
  }
}

SettingPage.defaultProps = {
  copy: {},
};
SettingPage.propTypes = {
  copy: PropTypes.shape({}),
  salonSetting: PropTypes.shape({}).isRequired,
  locale: PropTypes.string.isRequired,
  putSalonSettings: PropTypes.func.isRequired,
  getSpauthSeting: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  updateScalpCameraOption: PropTypes.func.isRequired,
  stylist: PropTypes.shape({}).isRequired,
  authSalonSettings: PropTypes.shape({}).isRequired,
  auth: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
  }).isRequired,
  // TODO: スカルプカメラ連携は Phase 2 対象外。cameraOption は、後で必要があれば復活させる。
  // cameraOption: PropTypes.shape({}).isRequired,
  // スカルプカメラ・ダウンロードマニュアルを取得する
  getScalpCameraGuide: PropTypes.func.isRequired,
  // TODO: スカルプカメラ連携は Phase 2 対象外。scalpCameraGuide は、後で必要があれば復活させる。
  // スカルプカメラ: マニュアル (Markdown テキスト、画像)、ボタン内文言「ダウンロード」、設定画面に表示するダウンロード催促文言、アプリダウンロードURL
  // scalpCameraGuide: PropTypes.shape({}).isRequired,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  salonSetting: state.salonSetting,
  authSalonSettings: state.authSalonSettings,
  locale: state.locale,
  auth: state.auth,
  stylist: state.user,
  users: state.users,
  // スカルプカメラアプリ使用可否、その保存状況
  cameraOption: state.cameraOption,
  // スカルプカメラ: マニュアル (Markdown テキスト、画像)、ボタン内文言「ダウンロード」、設定画面に表示するダウンロード催促文言、アプリダウンロードURL
  scalpCameraGuide: state.cameraOption.scalpCameraGuide,
});
const mapDispatch = dispatch => ({
  fetchUser: username => dispatch(fetchUser(username)),
  putSalonSettings: params => dispatch(putSalonSettings(params)),
  getSpauthSeting: salonId => dispatch(fechSpAuthSalonSettings(salonId)),
  // スカルプカメラアプリ使用可否を更新する (再レンダーを目的とする)
  updateScalpCameraOption: parameters => dispatch(updateScalpCameraOption(parameters)),
  // スカルプカメラ・ダウンロードマニュアルを取得する
  getScalpCameraGuide: locale => dispatch(getScalpCameraGuide(locale)),
});

const SettingPageForm = Form.create({ name: 'setting' })(SettingPage);
export default connect(mapState, mapDispatch)(SettingPageForm);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SettingPage/SettingPage.js